export function textToKey(text: string): string {
  return text
    .trim()
    .toLowerCase()
    .replace(/[ąćęłńóśźż]/g, (c) =>
      ({
        ą: "a",
        ć: "c",
        ę: "e",
        ł: "l",
        ń: "n",
        ó: "o",
        ś: "s",
        ź: "z",
        ż: "z",
      }[c] || c)
    )
    .replace(/\s+/g, "_")
    .replace(/[^a-z0-9_]/g, "");
}